// WfMetric — caixinha de métrica do wireframe (.wf-metric) com valor que SE
// AJUSTA à largura (MTR-03, admin 2026-06-12: "o custo tá quebrando a
// caixinha; o tamanho da fonte tem que ser de acordo com o tamanho da
// caixinha"). Fonte encolhe por degraus conforme o nº de caracteres — sempre
// 1 linha, sem overflow (nowrap + hidden de segurança no CSS).

function fitMetricFontSize(text: string): string | undefined {
  const n = text.length;
  if (n <= 8) return undefined; // 1.4rem padrão do .wf-metric-value
  if (n <= 11) return '1.1rem';
  if (n <= 14) return '0.92rem';
  if (n <= 18) return '0.78rem';
  return '0.68rem';
}

export function WfMetric({ value, label }: { value: string; label: string }) {
  return (
    <div className="wf-metric">
      <div
        className="wf-metric-value"
        style={fitMetricFontSize(value) ? { fontSize: fitMetricFontSize(value) } : undefined}
        title={value}
      >
        {value}
      </div>
      <div className="wf-metric-label">{label}</div>
    </div>
  );
}
